// Serviço de log remoto para capturar erros
class ErrorLogger {
  constructor() {
    this.endpoint = 'https://api.faeworks.com.br/log/error.php';
    this.userId = null;
  }

  setUserId(userId) {
    this.userId = userId;
  }

  async log(error, extraInfo = {}) {
    try {
      const errorData = {
        message: error.message || String(error),
        stack: error.stack || '',
        url: window.location.href,
        userAgent: navigator.userAgent,
        userId: this.userId,
        extraInfo: {
          ...extraInfo,
          timestamp: new Date().toISOString(),
          screen: {
            width: window.screen.width,
            height: window.screen.height,
          },
          viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
        },
      };

      // Enviar para o backend
      await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(errorData),
      });

      // Também logar no console
      console.error('Error logged:', errorData);
    } catch (logError) {
      // Se falhar ao enviar o log, apenas registrar no console
      console.error('Failed to send error log:', logError);
      console.error('Original error:', error);
    }
  }

  async logInfo(message, extraInfo = {}) {
    try {
      const logData = {
        message: message,
        stack: '',
        url: window.location.href,
        userAgent: navigator.userAgent,
        userId: this.userId,
        extraInfo: {
          ...extraInfo,
          type: 'info',
          timestamp: new Date().toISOString(),
        },
      };

      await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(logData),
      });

      console.log('Info logged:', message);
    } catch (logError) {
      console.error('Failed to send info log:', logError);
    }
  }
}

const errorLogger = new ErrorLogger();

// Capturar erros não tratados
window.addEventListener('error', (event) => {
  errorLogger.log(event.error || new Error(event.message), {
    type: 'unhandledError',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

// Capturar promises rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  errorLogger.log(event.reason || new Error('Unhandled Promise Rejection'), {
    type: 'unhandledRejection',
    promise: String(event.promise),
  });
});

export default errorLogger;
